const translations = {
    view: 'View'
};

export default translations;
